module.exports = require('./helpers/bundle-url').getBundleURL('4afSR') + "mp-logo.c08ff1aa.png";